import {
  Empty,
  EmptyDescription,
  EmptyHeader,
} from "@volca/ui/components/ui/empty";
import { emptyStateVariants } from "@volca/ui/lib/empty-state";
import { cn } from "@volca/ui/lib/utils";

export const PackPaneNote = ({
  children,
  destructive,
}: {
  children: string;
  destructive?: boolean;
}) => (
  <Empty
    role={destructive ? "alert" : undefined}
    className={emptyStateVariants({ layout: "collection" })}
  >
    <EmptyHeader>
      <EmptyDescription className={cn({ "text-danger": destructive })}>
        {children}
      </EmptyDescription>
    </EmptyHeader>
  </Empty>
);
